export default __webpack_public_path__ + "static/media/custo.7b85cbdb.svg";